import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router';
import { modal } from 'react-redux-modal';
import { LoginModalView } from '../../components';

class SocialLogin extends React.Component {
  constructor(props) {
    super(props);
    this.closeWindowOnRemove = this.closeWindowOnRemove.bind(this);
  }

  componentDidMount() {
    setTimeout(() => modal.add(LoginModalView, { title: '', size: 'medium', hideTitleBar: true, id: 'login', removeModalCallback: this.closeWindowOnRemove }), 500);
  }

  closeWindowOnRemove() {
    window.close();
  }

  render() {
    return (
      <div style={{ minHeight: 400 }} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};
export default connect(mapStateToProps)(SocialLogin);
